import React from 'react';
import { Box, Typography, Paper } from '@mui/material';
import EmailTemplateManagement from '../../components/admin/EmailTemplateManagement';

/**
 * Email Templates admin page (its own top-level admin entry, separate from PDF
 * Templates). Lets an admin view/edit/preview/reset the per-tenant email LAYOUTS.
 * The 21 notification types render through 6 editable family layouts.
 */
function EmailTemplatesPage() {
  return (
    <Box>
      <Typography variant="h4" gutterBottom>
        Email Templates
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
        Customise the HTML layout and subject of notification emails. Each layout is shared by a
        group of related notifications — editing a layout affects every notification in that group.
      </Typography>
      <Paper sx={{ p: 2 }}>
        <EmailTemplateManagement />
      </Paper>
    </Box>
  );
}

export default EmailTemplatesPage;
